import PropTypes from "prop-types";

import ACL_RELATIONSHIPS from "acl-relationships";
import Authorized from "components/Authorized";
import { TableCreateButton } from "components/BaseTableV3/TableCreateButton";
import CampaignPickerDialog from "routes/revenue_opportunity/components/CampaignPickerDialog";
import { useStartCreateRevenueOpportunity } from "routes/revenue_opportunity/useStartCreateRevenueOpportunity";

/** The table's create action, preset with the parent the table is scoped by. */
const NewRevenueOpportunityButton = ({
  entityId,
  campaignId,
  caseId,
  contactId,
}) => {
  const { start, isStarting, dialogProps } = useStartCreateRevenueOpportunity({
    entityId,
    campaignId,
    caseId,
    contactId,
  });

  return (
    <Authorized permissions={[ACL_RELATIONSHIPS.revenueOpportunity.create]}>
      <TableCreateButton isLoading={isStarting} onClick={start}>
        New Opportunity
      </TableCreateButton>
      <CampaignPickerDialog {...dialogProps} />
    </Authorized>
  );
};

const idType = PropTypes.oneOfType([PropTypes.number, PropTypes.string]);

NewRevenueOpportunityButton.propTypes = {
  entityId: idType,
  campaignId: idType,
  caseId: idType,
  contactId: idType,
};

export default NewRevenueOpportunityButton;
